import moment from "moment";

export const validateToken = () => {
  const token = localStorage.getItem("token") as any;

  if (token === "" || token === null || token === undefined) {
    return true;
  }
  const exp = JSON.parse(window.atob(token?.split(".")[1])).exp;
  if (Math.floor(Date.now() / 1000) >= exp) {
    return false;
  }
  return true;
};

export function formatDropDownValue(value: string) {
  return value ? value.split("_").join(" ").toUpperCase() : value;
}
export function formatDropDownValueNoUppercase(value: string) {
  return value ? value.split("_").join(" ") : value;
}
export function formatDateTime(date: string, format: string = "DD MMM'YY, LT") {
  return moment(date).format(format);
}
export function formatDate(date: string, format: string = "DD MMM'YY") {
  return moment(date).format(format);
}
export function getDaysDiff(date: string) {
  const d1 = moment(moment().format("YYYY-MM-DD"), 'YYYY-MM-DD');
  const d2 = moment(moment(date).format("YYYY-MM-DD"), 'YYYY-MM-DD')
  return d1.diff(d2, 'days')
  
  // moment(moment().format("YYYY-MM-DD") + " 00:00").diff(
  //   moment(formatDate(date) + " 00:00"),
  //   "days"
  // );
}

export function getSortDir(currentSort: any) {
  return currentSort == null ? "asc" : currentSort == "asc" ? "desc" : null;
}
export const convertFileSizeFromBytes = (bytes: number = 0) => {
  let ret = `${bytes}B`
  if(bytes > 1024){
    ret = `${Math.round(bytes/1024*100)/100}KB`
  }
  if(bytes > 1024*1024){
    ret = `${Math.round(bytes/1024/1024*100)/100}MB`
  }
  return ret;
}
export const debounce = (callback:any, wait:any) => {
  let timeoutId:any = null;
  return (...args:any) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback(...args);
    }, wait);
  };
}
export const validateLocalStorageCache = (key:string) => {
  key = 'cache_'+key;
  if(localStorage.getItem(key)){
    let data = JSON.parse(localStorage.getItem(key) || '{}');
    if(data.validTill && data.validTill > moment().valueOf()){
      return data.value
    }
  }
  return false;
}
export const saveInLocalStorageCache = (key:string, value:any, validTill: number) => {
  // validTill in minutes
  key = 'cache_'+key;
  localStorage.setItem(key, JSON.stringify({
    validTill: moment().add(validTill, 'minutes').valueOf(),
    value: value
  }))
}